<template>
    <div>
        <section>
            <h2 class="text-light-blue-pc4 text-bigger-size font-semibold mb-2 md:mb-5">
                <slot name="title" />
            </h2>
            <div class="text-xl-size">
                <slot name="about" />
            </div>
        </section>
    </div>
</template>

<style lang="postcss" scoped>
.text-xl-size > :not(:first-child) {
    @apply mt-2 md:mt-5;
}

</style>
